<mat-form-field
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel"
        [ngClass]="wrapperClasses">
    <mat-label>{{input.label}}</mat-label>
    <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate
               (blur)="blurEvent($event)"
               (focus)="focusEvent($event)"
               [formControl]="input.control" placeholder="Start date">
        <input matEndDate
               (blur)="blurEvent($event)"
               (focus)="focusEvent($event)"
               [formControl]="input.endDateFormControl" placeholder="End date">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix *ngIf="!input.control.disabled" [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker></mat-date-range-picker>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
    <mat-error>{{errorMessage}}</mat-error>
</mat-form-field>